import React from "react";
import "./Appraisal.css";
import { Link } from "react-router-dom";

export default function Appraisal({
  imageSrc,
  imageAlt = "Appraiser reviewing a residential property report at a Pacific Northwest home",
  onContactClick = () => {}, // Optional click handler
}) {
  // Default image from public folder using process.env.PUBLIC_URL
  const defaultImageSrc = `${process.env.PUBLIC_URL || ""}/howworks.webp`;
  const finalImageSrc = imageSrc || defaultImageSrc;

  return (
    <section className="Appraisal" aria-labelledby="appraisal-title">
      <div className="Appraisal__container">
        {/* LEFT: Content */}
        <div className="Appraisal__content">
          <h2 id="appraisal-title" className="Appraisal__title">
            Residential Appraisals You Can Rely On
          </h2>

          <p className="Appraisal__lead">
            Emerald Appraisal Services provides certified residential valuations across
            Pierce, King, Thurston, Lewis, Mason, Kitsap, Grays Harbor and Snohomish counties—so buyers,
            owners, lenders, and attorneys can make confident decisions with a clear,
            well-supported opinion of value.
          </p>

          <h3 className="Appraisal__h3">What You Can Expect</h3>

          <p className="Appraisal__body">
            From your first call, we clarify scope (purpose, effective date), gather details
            (access, upgrades, HOA), and schedule a site visit. We take interior and exterior
            photos, measure the home per ANSI standards, verify features and condition, and
            analyze recent comparable sales and market momentum. Most inspections take
            30 to 60 minutes depending on the property. Reports are USPAP-compliant, written in
            plain language, and typically delivered within 3–5 business days after the inspection.
          </p>

          <p className="Appraisal__body">
            We complete appraisals for purchases and refinances (including FHA), estate/date-of-death,
            divorce, pre-listing/pre-purchase, and assessment review. Property types include
            single-family homes, condos/townhomes, 2–4 unit small multi-family, and manufactured
            homes. Our goal is accuracy, transparency, and a report you can confidently share.
          </p>

          {/* Contact Us Button */}
         <Link to="/contact" className="Appraisal__cta">
  Contact Us
  <svg
    className="Appraisal__cta-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
      fill="currentColor"
    />
  </svg>
</Link>

        </div>

        {/* RIGHT: Image */}
        <div className="Appraisal__media">
          <div className="Appraisal__frame">
            <img
              className="Appraisal__img"
              src={finalImageSrc}
              alt={imageAlt}
              loading="lazy"
              decoding="async"
            />
            <div className="Appraisal__image-overlay"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
